export default {
    methods: {
        notifyError(response) {
            this.$q.notify({
                type: 'negative',
                message: this.$t('notify.error_message', {
                    message: response.data.message,
                }),
                timeout: 0,
                actions: [
                    {
                        label: this.$t('notify.dismiss'),
                    },
                ],
            })
        }
    }
}
